import { render, staticRenderFns } from "./assignmentCandidate.vue?vue&type=template&id=dff9e438&scoped=true&"
import script from "./assignmentCandidate.vue?vue&type=script&lang=js&"
export * from "./assignmentCandidate.vue?vue&type=script&lang=js&"
import style0 from "./assignmentCandidate.vue?vue&type=style&index=0&id=dff9e438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff9e438",
  null
  
)

export default component.exports